import { NumberScaleRating, Row, TextSpan } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { AnalyticsEventMetricResource } from "../analyticsTypes";

const Wrapper = styled.div`
	margin-top: ${({ theme }) => theme.spacing(8)};
`;

const Column = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: ${({ theme }) => theme.spacing(8)};
`;

const StyledRow = styled(Row)`
	align-items: start;
	padding-top: ${({ theme }) => theme.spacing(3)};
`;

interface Props {
	metrics: AnalyticsEventMetricResource;
}

export const MetricsOverview: FC<Props> = ({ metrics }) => {
	const { t } = useTranslation();

	return (
		<Wrapper>
			<div>
				<TextSpan $fontWeight="bold" $size="large">
					{t("Key metrics")}
				</TextSpan>
			</div>
			<Column>
				<div>
					<div>
						<TextSpan $fontWeight="bold">{t("Total number of event visitors")}</TextSpan>
					</div>
					<div>
						<TextSpan>{metrics.visitorsMetric || "-"}</TextSpan>
					</div>
				</div>
				<div>
					<div>
						<TextSpan $fontWeight="bold">{t("Invited persons")}</TextSpan>
					</div>
					<div>
						<TextSpan>{metrics.invitedPersonsMetric || "-"}</TextSpan>
					</div>
				</div>
				<div>
					<div>
						<TextSpan $fontWeight="bold">{t("Registrations")}</TextSpan>
					</div>
					<div>
						<TextSpan>{metrics.registrationsMetric || "-"}</TextSpan>
					</div>
				</div>
				<div>
					<div>
						<TextSpan $fontWeight="bold">{t("Customers on site")}</TextSpan>
					</div>
					<div>
						<TextSpan>{metrics.customersMetric || "-"}</TextSpan>
					</div>
				</div>
				<div>
					<div>
						<TextSpan $fontWeight="bold">{t("Employees on site")}</TextSpan>
					</div>
					<div>
						<TextSpan>{metrics.employeesMetric || "-"}</TextSpan>
					</div>
				</div>
				<div>
					<div>
						<TextSpan $fontWeight="bold">{t("Event reach")}</TextSpan>
					</div>
					<div>
						<TextSpan>{metrics.eventReachMetric || "-"}</TextSpan>
					</div>
				</div>
				<div>
					<div>
						<TextSpan $fontWeight="bold">{t("Has the event goal been achieved?")}</TextSpan>
					</div>
					<div>
						{metrics.eventGoalRatingMetric !== null ? (
							<StyledRow>
								<span>⌀ {metrics.eventGoalRatingMetric}</span>
								<NumberScaleRating rating={metrics.eventGoalRatingMetric} />
							</StyledRow>
						) : (
							"-"
						)}
					</div>
				</div>
			</Column>
		</Wrapper>
	);
};
